module.exports = __webpack_public_path__ + "static/media/the-one-women.e561ce0b.png";